namespace Matrix.Data {
    export interface TranslationForm {
        FromDomain: Serenity.StringEditor;
        ToDomain: Serenity.StringEditor;
        FromCode: Serenity.StringEditor;
        ToCode: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class TranslationForm extends Serenity.PrefixedContext {
        static formKey = 'Data.Translation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TranslationForm.init)  {
                TranslationForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(TranslationForm, [
                    'FromDomain', w0,
                    'ToDomain', w0,
                    'FromCode', w0,
                    'ToCode', w0,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2,
                    'Version', w1
                ]);
            }
        }
    }
}
